<template>
  <div>
    <div v-if="store.formSubmitted">
      <h2>Tack</h2>
      <p>Vänta dig svar om två veckor, ibland längre</p>
    </div>
    <form v-else-if="store.formFields.length" @submit.prevent="submitForm">
      <div v-for="field in store.formFields" :key="field.id" >
        <div class="form-field" :class="{ row : field.component === 'Switch', hidden : field.id === 'phone' }">
          <div style="flex-grow: 1;">
            <label :for="field.id" v-html="field.label" style="margin-bottom: 0.5em;"></label>
          </div>
          <div v-if="field.repeat">
            <InputField v-for="n in field.repeat" :field="field" :count="n" />
          </div>
          <div v-else style="flex-shrink: 1;">
            <InputField :field="field" />
          </div>
        </div>
        <div v-if="store.errors[field.id]" class="text-red-500">
          <p v-for="error in store.errors[field.id]" >
            {{ error }}
          </p>
        </div>
      </div>
      <button type="submit">Skicka</button>
    </form>
    <p v-else>
      Laddar formulär...
    </p>
  </div>
</template>

<script setup>
import {useStateStore} from "@/stores/store.js";
import {onMounted} from "vue";
import axios from "axios";
import InputField from "@/components/InputField.vue";

const store = useStateStore()
const apiURL = import.meta.env.VITE_API_URL

onMounted(() => {
  axios.get(apiURL + 'form-fields')
    .then(response => {
      store.formFields = response.data;
      createForm();
    })
    .catch(error => {
      console.log(error)
    })
})

function createForm() {
  for(let field of store.formFields) {
    if(field.repeat) {
      store.form[field.id] = new Array(field.repeat).fill('');
    } else {
      store.form[field.id] = '';
    }
  }
}

function submitForm() {
  axios.post(apiURL + 'form-submit', store.form)
    .then(response => {
      if(response.data.success) {
        store.formSubmitted = true;
      }
    })
    .catch(error => {
      store.errors = error.response.data.errors;
    })
}
</script>

<style scoped>
button {
  width: 100%;
}

form {
  width: auto;
}

.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

.hidden {
  display: none;
}

input {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.5rem;
}

.row {
  flex-direction: row;
  justify-content: space-between;
}

.text-red-500 {
  color: red;
}
</style>
